import { render, staticRenderFns } from "./group.vue?vue&type=template&id=96bc93aa&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc93aa",
  null
  
)

export default component.exports